module.exports = __webpack_public_path__ + "static/media/0015.d88a8869.jpg";